/** Theme boot helpers. The token sheets key on `body[data-ds-dark-theme]`, so
 * switching modes is one attribute on <body> — no class juggling, no re-import. */

/** Supported appearance modes. */
export type ThemeMode = 'light' | 'dark'

/** The attribute design-platform.css keys the dark token set on. */
export const DARK_ATTRIBUTE = 'data-ds-dark-theme'

/**
 * Apply a mode by toggling the dark attribute on <body>.
 * @param mode - 'dark' adds the attribute, 'light' removes it.
 */
export function applyTheme(mode: ThemeMode): void {
  if (mode === 'dark') document.body.setAttribute(DARK_ATTRIBUTE, '')
  else document.body.removeAttribute(DARK_ATTRIBUTE)
}

/**
 * Read the reader's OS colour-scheme preference.
 * @returns true when the OS asks for dark and the media query is available.
 */
export function prefersDark(): boolean {
  return typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-color-scheme: dark)').matches
}
